import { jsPDF } from "jspdf";
import format_number from "./number_formatter";
import moment from "moment";

export const showReport = (reportData) => {
  const deliveryNotesHeader = [
    "Client",
    "Service",
    "Type",
    "Débit",
    "Crédit",
    "Caisse",
  ];
  const doc = new jsPDF();

  const pageWidth = doc.internal.pageSize.width;
  const margin = 20;
  const availableWidth = pageWidth - 2 * margin;
  let columnWidths = [40, 30, 50, 25, 25, 35];

  const totalColumnWidth = columnWidths.reduce((sum, w) => sum + w, 0);
  if (totalColumnWidth > availableWidth) {
    const scaleFactor = availableWidth / totalColumnWidth;
    columnWidths = columnWidths.map((width) => width * scaleFactor);
  }

  const addHeader = () => {
    const img = new Image();
    img.src = "/logo.png";
    img.onload = () => {
      doc.addImage(img, "PNG", 15, 10, 90, 30);
      doc.setFontSize(14);
      doc.setFont("Arial", "bold");
      doc.text("STE KOUNOUZ TOURISM SUARL", 20, 50);

      doc.setFontSize(10);
      doc.setFont("Arial", "small");
      doc.text(
        `Société Unipersonnelle à responsabilité limitée\n` +
          `Résidente au capital de 700020.000.000 dinars\n` +
          `Siège social : Rue Italie Immeuble Bouchra – 4000 - Sousse\n` +
          `M.F. : 1214866P/A/M/000 – IU-RNE : 1214866P`,
        20,
        55
      );

      const pageHeight = doc.internal.pageSize.height;
      const pageBottomHeight = pageHeight - 10;
      const pageBottom =
        "Adresse : Rue Italie Immeuble Bochra - 4000 SOUSSE. TUNISIE. MF: 1214866P /AM-000";
      const bottomTextWidth = doc.getTextWidth(pageBottom);
      const bottomTextX = (pageWidth - bottomTextWidth) / 2;
      doc.text(pageBottom, bottomTextX, pageBottomHeight);

      doc.setFont("times", "bold");

      const title = `Rapport journalier de ${moment().format("DD-MM-YYYY")}`;
      const textWidth = doc.getTextWidth(title);
      const textX = (pageWidth - textWidth) / 2;
      doc.text(title, textX, 90);

      drawDeliveryTable();
      openPdf();
    };
    img.onerror = () => {
      console.error("Failed to load image");
      drawDeliveryTable();
      openPdf();
    };
  };

  const drawDeliveryTable = () => {
    doc.setFontSize(9);
    doc.setFont("Arial");

    const startX = margin;
    let startY = 100;
    let y = startY;
    const headerHeight = 10;
    const rowHeight = 10;

    deliveryNotesHeader.forEach((header, index) => {
      doc.setFillColor(200, 200, 200);
      const x =
        startX + columnWidths.slice(0, index).reduce((a, b) => a + b, 0);
      doc.rect(x, y, columnWidths[index], headerHeight, "F");
      doc.setTextColor(0);

      const textWidth = doc.getTextWidth(header);
      doc.text(
        header,
        x + columnWidths[index] / 2 - textWidth / 2,
        y + headerHeight / 2 + 3
      );
    });

    y += headerHeight;

    reportData?.forEach((row) => {
      if (row) {
        const rowValues = [
          row?.infosB2C
            ? row?.infosB2C?.fullName
            : row?.client
            ? row?.client?.name
            : "-",
          row.serviceName || "-",
          row.operationType?.designation || "-",
          row.debit ? format_number(row.debit) : "-",
          row.credit ? format_number(row.credit) : "-",
          row.checkout?.name || "-",
        ];

        rowValues.forEach((text, index) => {
          const columnWidth = columnWidths[index];
          const x =
            startX + columnWidths.slice(0, index).reduce((a, b) => a + b, 0);
          doc.rect(x, y, columnWidth, rowHeight);
          let displayText = text;
          const textWidth = doc.getTextWidth(text);

          if (textWidth > columnWidth - 6) {
            while (doc.getTextWidth(displayText + "...") > columnWidth - 6) {
              displayText = displayText.slice(0, -1);
            }
            displayText += "...";
          }

          const textX = x + columnWidth / 2 - doc.getTextWidth(displayText) / 2;
          const textY = y + rowHeight / 2 + 2;

          doc.text(displayText, textX, textY);
        });

        y += rowHeight;

        if (y + rowHeight > doc.internal.pageSize.height - 20) {
          doc.addPage();
          y = 20;
        }
      }
    });

    return y + 20;
  };

  const openPdf = () => {
    const pdfBlob = doc.output("blob");
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, "_blank");
  };

  addHeader();
};
